import React from 'react';

const DEFAULT_USER_DATA = {
    email: '',
    uuid: '',
};

const UserDataContext = React.createContext(DEFAULT_USER_DATA);

export { UserDataContext, DEFAULT_USER_DATA };



// WEBPACK FOOTER //
// ./src/EeckmanClientInfo/userDataContext.js